import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { Category } from '@sb-tools/typescript/models/category.model';
import { UserGroupsCategories } from '@sb-tools/typescript/models/user-groups-categories.model';
import { CommunityUser } from '@sb-tools/typescript/models/community-user.model';
import { UsersCategories } from '@sb-tools/typescript/models/users-categories.model';
import { AddOrEditCategoryModel } from '@core/models/add-or-edit-category-model.model';
import { CategoryBase } from '@sb-tools/typescript/models/category-base.model';
import { UserGroupWithMembersDTO } from '@sb-tools/typescript/models/dto/user-group-with-members.dto';

@Injectable({
    providedIn: 'root',
})
export class CategoriesDataService {
    constructor(private httpClient: HttpClient) {}

    addNewCategory(data: AddOrEditCategoryModel): Observable<Category> {
        return this.httpClient.post<Category>(environment.apiInboxUrl + 'admin/categories', data);
    }

    cloneCategory(category: Category, idOfCopiedCategory: number): Observable<CategoryBase> {
        return this.httpClient.post<CategoryBase>(
            environment.apiInboxUrl + 'admin/categories/' + idOfCopiedCategory + '/copy',
            { name: category.name },
        );
    }

    getAll(): Observable<Category[]> {
        return this.httpClient.get<Category[]>(environment.apiInboxUrl + 'categories', {
            params: { allCategories: true },
        });
    }

    getCategoryById(id: number): Observable<Category> {
        return this.httpClient.get<Category>(environment.apiInboxUrl + 'admin/categories/' + id);
    }

    getUserGroups(): Observable<UserGroupWithMembersDTO[]> {
        return this.httpClient.get<UserGroupWithMembersDTO[]>(
            environment.apiInboxUrl + 'userGroups?includeMembers=true',
        );
    }

    getCommunityMembers(): Observable<CommunityUser[]> {
        return this.httpClient.get<CommunityUser[]>(
            environment.apiInboxUrl + 'admin/users/communityMembers?includeVendors=false',
        );
    }

    removeCategory(id: number): Observable<void> {
        return this.httpClient.delete<void>(environment.apiInboxUrl + 'admin/categories/' + id);
    }

    updateAssignments(
        id: number,
        data: { userGroups: UserGroupsCategories[]; users: UsersCategories[] },
    ): Observable<void> {
        return this.httpClient.patch<void>(environment.apiInboxUrl + 'admin/categories/' + id + '/assignments', data);
    }

    updateCategories(data: Category[]): Observable<void> {
        return this.httpClient.patch<void>(environment.apiInboxUrl + 'admin/categories', data);
    }

    updateCategory(id: number, data: AddOrEditCategoryModel): Observable<Category> {
        return this.httpClient.patch<Category>(environment.apiInboxUrl + 'admin/categories/' + id, data);
    }
}
